export enum MentionCardHeightEnum {
    fixed = 'fixed',
    flexible = 'flexible'
}
